import { ApiError, fetchWithAuth } from "@entities/user-tokens";

import type { TaskOutcome } from "../TaskOutcome";

/**
 * タスクの結果情報を読む。まだ無ければ `null`。
 *
 * `null` になるのは組立より前のタスク、書込に失敗した完了タスク、そして**この器より前に完了した
 * 過去のタスク**である。過去のタスクは報告の段を後から呼べないので作り直せない。**空の器へ
 * 丸めない**のは、画面が「担当が 1 件も無い」と「結果情報そのものが無い」を区別して、後者では
 * 現行の一覧へ落ちる必要があるためである。
 */
export async function getTaskOutcome(
    projectId: string,
    taskId: string
): Promise<TaskOutcome | null> {
    const res = await fetchWithAuth(
        `/generation-tasks/${encodeURIComponent(taskId)}/outcome` +
            `?projectId=${encodeURIComponent(projectId)}`,
        { headers: { Accept: "application/json" } }
    );
    if (!res.ok) throw await ApiError.fromResponse(res, "生成結果の詳細を取得できませんでした");
    const body = (await res.json()) as { outcome: TaskOutcome | null };
    return body.outcome;
}
